export default function(){
  let _this = this;

  // Get settings
  let default_customdimensions = {};

  for(let setting_key in this.setting)
  {
    if(setting_key.startsWith('analytics__defaults_'))
    {
      default_customdimensions[setting_key.replace('analytics__defaults_','')]=this.setting[setting_key];
    }
  }

  // Is BlueConic loaded?
  let blueConicClient=false;
  if (typeof window.blueConicClient !== 'undefined' &&
      typeof window.blueConicClient.event !== 'undefined' &&
      typeof window.blueConicClient.event.subscribe !== 'undefined') {
      // BlueConic is loaded, now we can do API things
      blueConicClient=window.blueConicClient
  } else {
    // Not yet loaded; wait for the "onBlueConicLoaded" event
    window.addEventListener('onBlueConicLoaded', function () {
      // BlueConic is loaded, now we can do API things
      blueConicClient=window.blueConicClient;
    }, false);
  }

  let ga_matrix = {};
  ga_matrix['sitesection1']='dimension5';
  ga_matrix['sitesection2']='dimension1';
  ga_matrix['sitesection3']='dimension3';
  ga_matrix['sitesection4']='dimension6';
  ga_matrix['aboutness']='dimension13';

  ga_matrix['pagename']='dimension7';
  ga_matrix['pubdate']='dimension4';
  ga_matrix['contentid']='dimension9';
  ga_matrix['contenttype']='dimension2';
  ga_matrix['contenthierachy']='dimension8';
  ga_matrix['author']='dimension14';
  ga_matrix['formtype']='dimension16';
  ga_matrix['advertisername']='dimension17';
  ga_matrix['category_id']='dimension18';

  ga_matrix['userdemographic']='dimension19';
  ga_matrix['userid']='dimension10';
  ga_matrix['usertype']='dimension11';
  ga_matrix['userentitlement']='dimension12';
  ga_matrix['authstatus']='dimension15';

  let ga4_matrix = {};
  ga4_matrix['sitesection1']='site_section1';
  ga4_matrix['sitesection2']='site_section2';
  ga4_matrix['sitesection3']='site_section3';
  ga4_matrix['sitesection4']='site_section4';
  ga4_matrix['aboutness']='aboutness';

  ga4_matrix['pagename']='page_name';
  ga4_matrix['pubdate']='pub_date';
  ga4_matrix['contentid']='content_id';
  ga4_matrix['contenttype']='content_type';
  ga4_matrix['contenthierachy']='content_hierarchy';
  ga4_matrix['author']='author';
  ga4_matrix['formtype']='form_type';
  ga4_matrix['advertisername']='advertiser_name';
  ga4_matrix['category_id']='category_id';

  ga4_matrix['userdemographic']='user_demographic';
  ga4_matrix['userid']='userid';
  ga4_matrix['usertype']='user_type';
  ga4_matrix['userentitlement']='user_entitlement';
  ga4_matrix['authstatus']='auth_status';

  window.addEventListener("dsb-pwa-page_event", e => {
    if (typeof gtag === 'function')
    {
      let page_event = {};
      page_event.page_location = location.pathname+location.hash;

      if('detail' in e)
      {
        if('data' in e.detail)
        {
          e.detail.data = this.dsbClient.user._updateCustomDimensions(e.detail.data);

          if('userid' in e.detail.data)
          {
            e.detail.data['user_id']=e.detail.data.userid;
          }

          for(let data_key in e.detail.data)
          {
            if('id' === data_key)
            {
              page_event['contentid']=e.detail.data[data_key];
            }
            else
            {
              page_event[data_key]=e.detail.data[data_key];
            }
          }
        }

        let select_content = {};
        for(let page_view_key in page_event)
        {
          let _key = page_view_key.toLowerCase();
          if( _key in ga4_matrix)
          {
            select_content[ga4_matrix[_key]]=page_event[page_view_key];
          }
          else
          {
            select_content[_key]=page_event[page_view_key];
          }
        }

        if('event_type' in e.detail)
        {
          gtag('event', 'gwa_ev_'+e.detail.event_type, select_content);
          console.debug('dsb-pwa-page_event-GA4::',{'event_type':e.detail.event_type,'select_content':select_content});
        }
        else
        {
          console.error('dsb-pwa-page_event-GA4::','Missing event_type');
        }
      }
      else
      {
        console.error('dsb-pwa-page_event-GA4::','Missing detail or details.data');
      }
    }
    else
    {
      console.error('dsb-pwa-page_event:: GTAG is not available');
    }
  });

  window.addEventListener("dsb-pwa-page_view", e => {
    try
    {
      if (typeof ga === 'function')
      {
        let customDimensions = {};
        let page_url = location.pathname+location.hash;
        // gwa_pageName & gwa_aboutness & gwa_contentType & gwa_ContentId & gwa_author
        if('detail' in e)
        {
          if('append' in e.detail)
          {
            page_url = page_url+"/-/"+e.detail.append;
          }

          if('customDimensions' in e.detail)
          {
            customDimensions = e.detail.customDimensions;
          }
          else if('gwa' in e.detail)
          {
            customDimensions = e.detail.gwa;
          }

          if('date' in e.detail && !('pubdate' in customDimensions))
          {
            customDimensions.pubdate = e.detail.date;
          }

          if('id' in e.detail && !('contentid' in customDimensions))
          {
            customDimensions.contentid = e.detail.id;
          }

          if('author' in e.detail && !('author' in customDimensions))
          {
            customDimensions.author = e.detail.author;
          }

          if('taxonomies' in e.detail && !('aboutness' in customDimensions))
          {
            customDimensions.aboutness = [];
            if(e.detail.taxonomies !== null && typeof Array.isArray(e.detail.taxonomies))
            {
              let sitesection_count = 2;
              for(let i = 0; i < e.detail.taxonomies.length; i++)
              {
                if(sitesection_count<5)
                {
                  customDimensions['sitesection'+sitesection_count] = e.detail.taxonomies[i];
                }
                customDimensions.aboutness.push(e.detail.taxonomies[i]);
                sitesection_count++;
                }
            }
          }

          if('types' in e.detail && !('contenttype' in customDimensions))
          {
            customDimensions.contenttype = [];
            if(e.detail.types !== null && Array.isArray(e.detail.types))
            {
              for(let i = 0; i < e.detail.types.length; i++)
              {
                customDimensions.contenttype.push(e.detail.types[i]);
              }
            }
          }

          if('title' in e.detail)
          {
            customDimensions['contenttitle'] = e.detail.title;
            _this._update_DocumentTitle(customDimensions['contenttitle']);
            ga('set', 'title', customDimensions['contenttitle']);
          }
        }

        // Add user dimensions
        customDimensions = this.dsbClient.user._updateCustomDimensions(customDimensions);


        if('userid' in customDimensions)
        {
          customDimensions['user_id']=customDimensions.userid;
        }


        //customDimensions.account = 'account';

        // Set defaults
        customDimensions.sitesection1 = 'fwi-pwa';

        for(let default_customdimension in default_customdimensions)
        {
          customDimensions[default_customdimension]=default_customdimensions[default_customdimension];
        }

        if(!('contenthierachy' in customDimensions))
        {
          customDimensions.contenthierachy = [];
          customDimensions.contenthierachy.push(customDimensions.sitesection1);

          // Setup contenthierachy
          let contenthierachy_parts = ['sitesection2','sitesection3','sitesection4','contenttitle'];
          for(let i = 0; i < contenthierachy_parts.length; i++)
          {
            if(contenthierachy_parts[i] in customDimensions)
            {
              customDimensions.contenthierachy.push(customDimensions[contenthierachy_parts[i]]);
            }
          }
          customDimensions.contenthierachy = customDimensions.contenthierachy.join('|');
        }

        if(!('pagename' in customDimensions))
        {
          customDimensions.pagename = customDimensions.contenthierachy;
        }

        // Collapse aboutness
        if(!('aboutness' in customDimensions) || (Array.isArray(customDimensions.aboutness) && customDimensions.aboutness.length == 0))
        {
          // Set Aboutness
          customDimensions.aboutness = [];

          if('sitesection2' in customDimensions)
          {
            customDimensions.aboutness.push(customDimensions.sitesection2);
          }
          if('sitesection3' in customDimensions)
          {
            customDimensions.aboutness.push(customDimensions.sitesection3);
          }
          if('sitesection4' in customDimensions)
          {
            customDimensions.aboutness.push(customDimensions.sitesection4);
          }
        }
        if(Array.isArray(customDimensions.aboutness))
        {
          customDimensions.aboutness = customDimensions.aboutness.join('|');
        }

        // Collapse contenttype
        if(!('contenttype' in customDimensions) || (Array.isArray(customDimensions.contenttype) && customDimensions.contenttype.length == 0))
        {
          // Set contenttype
          customDimensions.contenttype = [];
          customDimensions.contenttype.push('unknown');
        }
        if(Array.isArray(customDimensions.contenttype))
        {
          customDimensions.contenttype = customDimensions.contenttype.join('|');
        }

        // Remove contenttitle (not used)
        if('contenttitle' in customDimensions)
        {
          delete customDimensions['contenttitle'];
        }

        for(let aDimensions in customDimensions)
        {
          if(typeof customDimensions[aDimensions] == 'string')
          {
            customDimensions[aDimensions] = customDimensions[aDimensions].toLowerCase();
          }

          if(aDimensions.toLowerCase() in ga_matrix)
          {
            ga('set', ga_matrix[aDimensions.toLowerCase()], customDimensions[aDimensions]);
          }
          else
          {
            console.error('dsb-pwa-page_view:: Unknown customDimension (GWA) tag "'+aDimensions+'"!',ga_matrix);
          }
        }

        console.debug('dsb-pwa-page_view::',customDimensions);

        ga('set', 'page', page_url);
        ga('send', 'pageview')
      }
      else
      {
        console.error('dsb-pwa-page_view:: GA is not available');
      }

      if (typeof gtag === 'function')
      {
        let customDimensions = {};
        let page_view = {};
        page_view.page_location = location.pathname+location.hash;
        // gwa_pageName & gwa_aboutness & gwa_contentType & gwa_ContentId & gwa_author
        if('detail' in e)
        {
          if('append' in e.detail)
          {
            page_view.page_location = page_view.page_location+"/-/"+e.detail.append;
          }

          if('customDimensions' in e.detail)
          {
            customDimensions = e.detail.customDimensions;
          }
          else if('gwa' in e.detail)
          {
            customDimensions = e.detail.gwa;
          }

          if('date' in e.detail && !('pubdate' in customDimensions))
          {
            customDimensions.pubdate = e.detail.date;
          }

          if('id' in e.detail && !('contentid' in customDimensions))
          {
            customDimensions.contentid = e.detail.id;
          }

          if('author' in e.detail && !('author' in customDimensions))
          {
            customDimensions.author = e.detail.author;
          }

          if('taxonomies' in e.detail && !('aboutness' in customDimensions))
          {
            customDimensions.aboutness = [];
            if(e.detail.taxonomies !== null && typeof Array.isArray(e.detail.taxonomies))
            {
              let sitesection_count = 2;
              for(let i = 0; i < e.detail.taxonomies.length; i++)
              {
                if(sitesection_count<5)
                {
                  customDimensions['sitesection'+sitesection_count] = e.detail.taxonomies[i];
                }
                customDimensions.aboutness.push(e.detail.taxonomies[i]);
                sitesection_count++;
                }
            }
          }

          if('types' in e.detail && !('contenttype' in customDimensions))
          {
            customDimensions.contenttype = [];
            if(e.detail.types !== null && Array.isArray(e.detail.types))
            {
              for(let i = 0; i < e.detail.types.length; i++)
              {
                customDimensions.contenttype.push(e.detail.types[i]);
              }
            }
          }

          if('title' in e.detail)
          {
            customDimensions['contenttitle'] = e.detail.title;
            _this._update_DocumentTitle(customDimensions['contenttitle']);
            page_view.page_title = customDimensions['contenttitle'];
          }
        }

        // Add user dimensions
        customDimensions = this.dsbClient.user._updateCustomDimensions(customDimensions);

        if('userid' in customDimensions)
        {
          customDimensions['user_id']=customDimensions.userid;
        }

        //customDimensions.account = 'account';

        // Set defaults
        customDimensions.sitesection1 = 'fwi-pwa';

        for(let default_customdimension in default_customdimensions)
        {
          customDimensions[default_customdimension]=default_customdimensions[default_customdimension];
        }

        if(!('contenthierachy' in customDimensions))
        {
          customDimensions.contenthierachy = [];
          customDimensions.contenthierachy.push(customDimensions.sitesection1);

          // Setup contenthierachy
          let contenthierachy_parts = ['sitesection2','sitesection3','sitesection4','contenttitle'];
          for(let i = 0; i < contenthierachy_parts.length; i++)
          {
            if(contenthierachy_parts[i] in customDimensions)
            {
              customDimensions.contenthierachy.push(customDimensions[contenthierachy_parts[i]]);
            }
          }
          customDimensions.contenthierachy = customDimensions.contenthierachy.join('|');
        }

        if(!('pagename' in customDimensions))
        {
          customDimensions.pagename = customDimensions.contenthierachy;
        }

        // Collapse aboutness
        if(!('aboutness' in customDimensions) || (Array.isArray(customDimensions.aboutness) && customDimensions.aboutness.length == 0))
        {
          // Set Aboutness
          customDimensions.aboutness = [];

          if('sitesection2' in customDimensions)
          {
            customDimensions.aboutness.push(customDimensions.sitesection2);
          }
          if('sitesection3' in customDimensions)
          {
            customDimensions.aboutness.push(customDimensions.sitesection3);
          }
          if('sitesection4' in customDimensions)
          {
            customDimensions.aboutness.push(customDimensions.sitesection4);
          }
        }
        if(Array.isArray(customDimensions.aboutness))
        {
          customDimensions.aboutness = customDimensions.aboutness.join('|');
        }

        // Collapse contenttype
        if(!('contenttype' in customDimensions) || (Array.isArray(customDimensions.contenttype) && customDimensions.contenttype.length == 0))
        {
          // Set contenttype
          customDimensions.contenttype = [];
          customDimensions.contenttype.push('unknown');
        }
        if(Array.isArray(customDimensions.contenttype))
        {
          customDimensions.contenttype = customDimensions.contenttype.join('|');
        }

        // Remove contenttitle (not used)
        if('contenttitle' in customDimensions)
        {
          delete customDimensions['contenttitle'];
        }

        for(let aDimensions in customDimensions)
        {
          if(typeof customDimensions[aDimensions] == 'string')
          {
            customDimensions[aDimensions] = customDimensions[aDimensions].toLowerCase();
          }

          if(aDimensions.toLowerCase() in ga4_matrix)
          {
            page_view[aDimensions.toLowerCase()]=customDimensions[aDimensions];
          }
          else
          {
            console.error('dsb-pwa-page_view:: Unknown customDimension (GWA) tag "'+aDimensions+'"!',ga_matrix);
          }
        }

        let select_content = {};
        for(let page_view_key in page_view)
        {
          let _key = page_view_key.toLowerCase();
          if( _key in ga4_matrix)
          {
            select_content[ga4_matrix[_key]]=page_view[page_view_key];
          }
          else
          {
            select_content[_key]=page_view[page_view_key];
          }
        }

        //let select_content = JSON.parse(JSON.stringify(page_view));

        //page_view.select_content=_customDimensions;
        if('event_type' in e.detail)
        {
          gtag('event', e.detail.event_type, select_content);
        }
        else
        {
          //gtag('event', 'select_content', select_content);
          //gtag('event', 'page_view', page_view);
          gtag('event', 'page_view', select_content);
          if(blueConicClient && ('handlePageView' in blueConicClient) && (typeof blueConicClient.handlePageView == 'function'))
          {
            try
            {
              blueConicClient.handlePageView();
              console.debug('dsb-pwa-page_view:: blueConicClient handlePageView executed');
            }
            catch(ex)
            {
                console.error('dsb-pwa-page_view:: blueConicClient error',ex);
            }
          }
          else
          {
            console.warn('dsb-pwa-page_view:: blueConicClient not ready');
          }
        }
        //console.debug('dsb-pwa-page_view-GA4::',{'page_view':page_view,'select_content':select_content});
        console.debug('dsb-pwa-page_view-GA4::',{'select_content':select_content});
      }
      else
      {
        console.error('dsb-pwa-page_view:: GTAG is not available');
      }
    }
    catch(ex)
    {
      console.error('dsb-pwa-page_view:: Error occured in detail',ex);
    }
  });
}
